'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialYenOutline = function IoSocialYenOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 2.5l-8.7 16.3h3.7v3.7h-5.7l-1.2 2.4v1.4h6.9v3.7h-6.9v7.5h-6.2v-7.5h-6.9v-3.7h6.9v-1.4l-1.1-2.4h-5.8v-3.7h3.8l-8.8-16.3h6.3l8.7 17.3 8.8-17.3h6.2z m-6.2 17.5h-4.7l1.1-1.9 7.7-14.3h-3.4l-9.5 18.7-9.5-18.7h-3.4l7.7 14.3 1.1 1.9h-4.6v1.3h5.3l1.5 3.4v2.8h-6.8v1.3h6.8v7.5h3.8v-7.5h6.9v-1.3h-6.9v-2.9l1.6-3.3h5.3v-1.3z' })
        )
    );
};

exports.default = IoSocialYenOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-yen-outline.js
// module id = 2521
// module chunks = 0